import axios from 'axios';
import types from '../constants';
import { ARTICLES_RECOMMENDED_ENDPOINT } from '../api/common/endpoints';

export const getHomeArticlesByIdx = (idx = []) => async (
  dispatch,
  getState
) => {
  dispatch({
    type: types.GET_HOME_ARTICLES_LOADING,
    payload: {}
  });

  let promiseCollection = [];
  idx.map(category_id => {
    const x = new Promise(resolve => {
      axios
        .get(`${ARTICLES_RECOMMENDED_ENDPOINT}/${category_id}`)
        .then(response => {
          const data = response.data || response;
          resolve(data);
        })
        .catch(error => {
          console.log(
            `Failed to request per individual article category [${category_id}]`,
            error
          );
          resolve(null);
        });
    });

    promiseCollection.push(x);
  });

  Promise.all(promiseCollection)
    .then(articles => {
      let result = articles.reduce((array, article) => {
        if (article) {
          array.push(article);
        }
        return array;
      }, []);

      dispatch({
        type: types.GET_HOME_ARTICLES_SUCCESS,
        payload: {
          meta: {
            status: result.length > 0 ? 'success' : 'no_result',
            error: ''
          },
          data: result
        }
      });
    })
    .catch(error => {
      dispatch({
        type: types.GET_HOME_ARTICLES_ERROR,
        payload: {
          meta: {
            status: 'no_result',
            error: error
          },
          data: []
        }
      });
    });
};
